import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";

const LOGO = "https://customer-assets.emergentagent.com/job_cec63a27-6a0f-4a75-b23c-f51d63e453bf/artifacts/nuiygtwq_ChatGPT%20Image%20May%2012%2C%202026%2C%2007_59_58%20AM.png";

const TABS = [
  { num: "001", label: "The Rig", href: "#the-rig" },
  { num: "002", label: "The Process", href: "#how-it-works" },
  { num: "003", label: "Ballpark", href: "#calculator" },
  { num: "004", label: "BYO Booze", href: "#byo" },
  { num: "005", label: "Service Area", href: "#service-area" },
  { num: "006", label: "RSVP", href: "#inquiry" },
  { num: "007", label: "FAQ", href: "#faq" },
];

export default function Navbar() {
  const loc = useLocation();
  const onLanding = loc.pathname === "/";
  const [active, setActive] = useState("");

  useEffect(() => {
    if (!onLanding) return;
    const sectionIds = TABS.map((t) => t.href.slice(1));
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) setActive(e.target.id);
        });
      },
      { rootMargin: "-40% 0px -55% 0px", threshold: 0 }
    );
    sectionIds.forEach((id) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
  }, [onLanding]);

  return (
    <header
      data-testid="site-navbar"
      className="sticky top-0 z-40 bg-[#e8dcc4]/95 backdrop-blur border-b border-[#c9bfa6]"
    >
      {/* Brand row */}
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-3 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="nav-logo">
          <img src={LOGO} alt="Trailhead Taps" className="h-12 w-12 object-contain" />
          <div className="leading-tight">
            <div className="font-display text-xl font-bold text-[#1f2e1f]">Trailhead Taps</div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-[#c97b3a]">Mobile Beer Trailers</div>
          </div>
        </Link>
        <div className="flex items-center gap-2">
          <Link to="/dashboard" className="hidden sm:inline text-xs uppercase tracking-[0.25em] text-[#1f2e1f] hover:text-[#c97b3a] transition-colors px-3" data-testid="nav-dashboard">
            Admin
          </Link>
          {onLanding && (
            <Button asChild className="btn-orange rounded-full px-5" data-testid="nav-cta-book">
              <a href="#inquiry">Request a Quote</a>
            </Button>
          )}
        </div>
      </div>

      {/* Section tabs row (only on landing) */}
      {onLanding && (
        <nav className="border-t border-[#c9bfa6]/60 bg-[#f4ecd8]/70" data-testid="section-tabs">
          <div className="max-w-7xl mx-auto px-2 md:px-8 overflow-x-auto">
            <ul className="flex items-stretch min-w-max">
              {TABS.map((t) => {
                const isActive = active === t.href.slice(1);
                return (
                  <li key={t.num} className="flex-shrink-0">
                    <a
                      href={t.href}
                      data-testid={`tab-${t.num}`}
                      className={`flex items-center gap-2 px-3 md:px-5 py-3 border-b-2 transition-all ${
                        isActive
                          ? "border-[#c97b3a] text-[#1f2e1f] bg-[#e8dcc4]"
                          : "border-transparent text-[#5a5245] hover:text-[#c97b3a] hover:border-[#c97b3a]/40"
                      }`}
                    >
                      <span className={`text-[10px] uppercase tracking-[0.2em] font-bold ${isActive ? "text-[#c97b3a]" : "text-[#8c8577]"}`}>
                        {t.num}
                      </span>
                      <span className="font-display text-sm md:text-base whitespace-nowrap">{t.label}</span>
                    </a>
                  </li>
                );
              })}
            </ul>
          </div>
        </nav>
      )}
    </header>
  );
}
